/**
 * Utility functions for string formatting and manipulation
 */

/**
 * Formats a camelCase or PascalCase field name to be more readable
 * Converts field names like "dateCreated" to "Date Created" or "userId" to "User"
 *
 * @param fieldName - The field name to format
 * @returns Formatted, human-readable field name
 */
export const formatFieldName = (fieldName: string): string => {
	return fieldName
		.replace(/([A-Z])/g, " $1") // Add space before capital letters
		.replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
		.replace(/Id$/, "") // Remove "Id" suffix
		.trim(); // Remove any extra whitespace
};

/**
 * Converts a string to title case (first letter of each word capitalized)
 *
 * @param text - The text to convert
 * @returns Title case string
 */
export const toTitleCase = (text: string): string => {
	return text
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(" ");
};

/**
 * Converts a kebab-case or snake_case string to camelCase
 *
 * @param text - The text to convert
 * @returns camelCase string
 */
export const toCamelCase = (text: string): string => {
	return text
		.replace(/[-_](.)/g, (_, char) => char.toUpperCase())
		.replace(/^(.)/, (char) => char.toLowerCase());
};
